var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center admin-footer",attrs:{"id":"AdminFooter"}},[_vm._v(" Copyright By Piesoft Co.,Ltd. | Version "+_vm._s(_vm.appVersion)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }